import { Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import AuthGuard from './guards/authGuard';
import ProjectsPage from '../containers/projects';
import ProjectWorkspace from '../containers/projectWorkspace';

const ProtectedRoutes = {
  path: '/portal',
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      index: true,
      element: <ProjectsPage />,
    },
    {
      path: 'projects/:projectId',
      element: <ProjectWorkspace />,
    },
    {
      path: '*',
      element: <Navigate to="/portal" replace />,
    },
  ],
};

export default ProtectedRoutes;
